import { render, staticRenderFns } from "./ChatEmotion.vue?vue&type=template&id=1a807e4e&scoped=true"
import script from "./ChatEmotion.vue?vue&type=script&lang=js"
export * from "./ChatEmotion.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotion.vue?vue&type=style&index=0&id=1a807e4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a807e4e",
  null
  
)

export default component.exports